import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import img from "../../../../../../assets/image/youtube.png";
import "./MiddleCard.css";

const MiddleCard0 = ({ newsItem, cart }) => {
  const { title, image, date_stamp, _id, youtube_embed, short_text } = newsItem;

  // Bengali date
  const dates = new Date(date_stamp);
  const options = { year: "numeric", month: "long", day: "numeric" };
  const dateInBengali = dates.toLocaleDateString("bn-IN", options);
  const [timeDifference, setTimeDifference] = useState("");
  useEffect(() => {
    const backendDate = new Date(date_stamp);

    const banglaDigits = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];

    const convertToBanglaDigits = (number) =>
      number
        .toString()
        .split("")
        .map((digit) => banglaDigits[parseInt(digit)])
        .join("");

    const calculateTimeDifference = () => {
      const now = new Date();
      const diff = now - backendDate;

      const seconds = Math.floor(diff / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days < 10) {
        if (days > 0) return `${convertToBanglaDigits(days)} দিন আগে`;
        if (hours > 0) return `${convertToBanglaDigits(hours)} ঘন্টা আগে`;
        if (minutes > 0) return `${convertToBanglaDigits(minutes)} মিনিট আগে`;
        return `${convertToBanglaDigits(seconds)} সেকেন্ড আগে`;
      }
      return dateInBengali;
    };

    setTimeDifference(calculateTimeDifference());

    const interval = setInterval(() => {
      setTimeDifference(calculateTimeDifference());
    }, 60000);

    return () => clearInterval(interval);
  }, [date_stamp, dateInBengali]);
  const date = new Date(parseInt(_id));
  const moreButtonYear = date.getFullYear();

  const limitShortText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + "...";
  };
  return (
      <div className={`fast${cart}`}>
        <div className={`my-3 border-b-[1px] border-[#ccc] pb-3 `}>
          <Link
            to={`/newsDetails/${_id}`}
            className="no-underline text-inherit"
          >
            <div className={`flexBox gap-3 items-start`}>
              <div>
                <h6 className=" font-bold leading-snug text-[27px] text-red-600 hover:text-red-700 NewsFontTitle">
                  {title}
                </h6>
                <p className="my-3 text-slate-700 text-md newsTitle">
                  {limitShortText(short_text, 250)}
              </p>
              <div>
              <p className="text-[12px] NewsFontTitle font-thin text-gray-400 mt-1">{timeDifference}</p>
            </div>
              </div>
              {/* IMAGE FIXED HERE */}
              <figure className={`relative w-80 h-34 overflow-hidden flex-shrink-0 MiddleImageFast${cart}`}>
                <img
                  src={`https://www.iskconbangla.com/img/${moreButtonYear}_news_sm/${image}`}
                  alt="news"
                  className="w-full h-full object-cover"
                />

                {youtube_embed && (
                  <img
                    src={img}
                    alt="YouTube"
                    className="w-8 h-8 absolute bottom-1 right-1"
                  />
                )}
              </figure>
            </div>
            
          </Link>
        </div>
    </div>
  );
};

export default MiddleCard0;
